import type { FC } from 'react';

import { targetElement } from '../../../utils/event_target';
import IconButton from '../../icon_button/icon_button';

const OpenContextMenuButton: FC = () => (
  <IconButton
    iconName="menu_context"
    aria={{ label: 'Open context menu' }}
    onClick={(originalEvent) => {
      const target = targetElement(originalEvent.target);
      if (!target) {
        return;
      }
      const rect = target.getBoundingClientRect();
      const event = new MouseEvent('contextmenu', {
        ...originalEvent,
        view: window,
        clientX: rect.left,
        clientY: rect.bottom,
      });
      target.dispatchEvent(event);
    }}
  />
);

export default OpenContextMenuButton;
